<script setup lang="ts">
const props = defineProps<
  {
    title?: string;
    description?: string;
    confirmLabel?: string;
    cancelLabel?: string;
  }
>();

const emit = defineEmits(["on-click", "on-close"]);

const { isLoading, execute: onAsyncClick } = useAsyncState(
  (fn: (() => void) | (() => Promise<void>)) => Promise.resolve().then(fn),
  undefined,
  { immediate: false },
);

function onActionClick(action: "confirm" | "cancel"): Promise<void> {
  if (action === "confirm")
    return onAsyncClick(0, () => emit("on-click"));
  else if (action === "cancel")
    return onAsyncClick(0, () => emit("on-close"));
  return onAsyncClick(0, Promise.resolve);
}
</script>

<template>
  <div class="max-w-[30rem] bg-white dark:bg-[#2c374b]  rounded-md shadow-md">
    <div class="flex flex-col gap-6 px-6 pb-8 pt-4">
      <div class="flex w-full justify-center items-center">
        <IconSurvey />
      </div>
      <div class="text-black dark:text-white space-y-4">
        <h1 class="text-lg font-bold">
          {{ props.title }}
        </h1>
        <p class="text-sm font-medium text-[var(--base-secondary-text-color)]">
          {{ props.description }}
        </p>
      </div>
      <div class="flex gap-4">
        <BaseButton
          name="later"
          class="flex-1 font-bold !bg-[#465269]"
          :disabled="isLoading"
          @click="onActionClick('cancel')"
        >
          {{ props.cancelLabel }}
        </BaseButton>

        <BaseButton
          name="continue"
          class="flex-1 font-bold "
          :disabled="isLoading"
          @click="onActionClick('confirm')"
        >
          {{ props.confirmLabel }}
        </BaseButton>
      </div>
    </div>
  </div>
</template>
